import React from 'react';
import AdminLayout from '../../../components/Layout/AdminLayout';
import CancellationPolicies from './CancellationPolicies';
import { restrictUrls } from '../../../helpers/adminPrivileges';

const title = 'Cancellation Policies';

export default async function action({ store }) {
  // From Redux Store
  let isAdminAuthenticated = store.getState().runtime.isAdminAuthenticated;
  const adminPrivileges = store.getState().account.privileges && store.getState().account.privileges.privileges;
  const privileges = store.getState().listSettings && store.getState().listSettings.privileges;

  if (!isAdminAuthenticated) {
    return { redirect: '/siteadmin/login' };
  }

  // Admin restriction - using same privilege as home page settings (15)
  if (!restrictUrls('/siteadmin/home/cancellation-policies', adminPrivileges, privileges)) {
    return { redirect: '/siteadmin' };
  }

  return {
    title,
    component: <AdminLayout><CancellationPolicies title={title} /></AdminLayout>,
  };
}
